import { Box, Chip, Typography, useTheme, alpha } from '@mui/material';
import dayjs from 'dayjs';
import { LabelCaps } from './LabelCaps';
import type { Catalog, SubscriptionState } from '../../utils/subscriptionApi';

interface PlanHeaderProps {
  state: SubscriptionState;
  primary: Catalog;
}

const PLAN_DISPLAY_NAME: Record<SubscriptionState['tier'], string> = {
  creator: 'Creator',
  commercial: 'Commercial',
};

export const PlanHeader: React.FC<PlanHeaderProps> = ({ state, primary }) => {
  const theme = useTheme();
  const renewLabel = primary.renewDate && dayjs(primary.renewDate).isValid()
    ? dayjs(primary.renewDate).format('MMM D, YYYY')
    : null;

  return (
    <Box sx={{ p: 3 }}>
      <LabelCaps>Current Plan</LabelCaps>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 0.5 }}>
        <Typography variant="h4" sx={{ mb: 0 }}>
          {PLAN_DISPLAY_NAME[state.tier]}
        </Typography>
        <Chip
          label="Active"
          size="small"
          sx={{
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.main,
            fontWeight: 600,
          }}
        />
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        ALI ID:{' '}
        <Box component="span" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
          {primary.catalogAliId}
        </Box>
        {renewLabel && (
          <>
            <Box component="span" sx={{ mx: 1, color: 'divider' }}>·</Box>
            Renews {renewLabel}
          </>
        )}
      </Typography>
    </Box>
  );
};
